import React, { useState, useRef, useEffect } from 'react'
import Message from './message'

const Messages = ({ messages, channelId, adminPlayerId, adminImageUrl, selectedPlayer, scroll, fetchMore, onDeleteMessage }) => {
  const [stopScroll, setStopScroll] = useState(false)
  const messagesRef = useRef()

  useEffect(() => {
    const container = messagesRef.current    

    if (!container) return

    if (scroll == 'top') container.scrollTop = 0
    if (scroll == 'bottom') {
      container.scrollTop = container.scrollHeight - container.clientHeight
    }
  })

  const onWheelCapture = e => {
    if (!stopScroll && e.currentTarget.scrollTop == 0 && e.deltaY < 0 && messages && messages.length) {
      setStopScroll(true)
      fetchMore({ id: channelId })
      setTimeout(() => { setStopScroll(false) }, 500)
    }
  }

  return <div className='messages-cell chat-body' onWheelCapture={onWheelCapture} ref={messagesRef}>
    { messages && selectedPlayer &&
      <div className='messages'>
        { messages.map(m =>
          <Message
            key={m.id}
            imageUrl={(m.sender == adminPlayerId ? adminImageUrl : selectedPlayer.avatar) || '/images/ic_user@2x.png'}
            player={m.sender == adminPlayerId ? 'Plei Admin' : selectedPlayer.name}
            date={m.date.toDate()}
            admin={m.sender == adminPlayerId}
            message={m}
            onDelete={() => onDeleteMessage({ channelId: channelId, id: m.id })}
          />
        )}
      </div>
    }
  </div>
}

export default Messages
